import React from 'react';
import { useInView } from 'react-intersection-observer';
import { CircleDollarSign, HelpCircle, ArrowRight } from 'lucide-react';
import { RiFileExcel2Fill } from 'react-icons/ri';

const ValueProposition: React.FC = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const values = [
    {
      icon: RiFileExcel2Fill,
      title: 'Excelの限界',
      isExcel: true,
      description: '顧客管理、在庫管理、シフト管理…全部Excelで回しているけど、もう限界。データが壊れる、誰かが上書きする、集計に半日かかる。',
    },
    {
      icon: CircleDollarSign,
      title: '見積もりが高すぎる',
      description: 'IT会社に相談したら500万、1000万と言われた。うちみたいな小さい会社には手が出ない。でも紙とExcelのままじゃ成長できない…',
    },
    {
      icon: HelpCircle,
      title: '何を頼めばいいか分からない',
      description: '業務効率化のお悩みをそのまま相談してください。状況をお聞きすれば、どうすれば良いか瞬時にアイデアをお出しします。ITの知識は一切不要です。',
    }
  ];

  return (
    <section id="problems" className="relative py-20 lg:py-28 bg-[#1B2A4A] overflow-hidden">
      <div className="relative mx-auto max-w-6xl px-5 lg:px-6">
        <div ref={ref} className={`transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-4 py-1.5 mb-6">
              <span className="text-sm font-semibold text-[#B8860B]">よくあるお悩み</span>
            </div>
            <h2 className="text-3xl font-bold lg:text-4xl leading-tight text-[#F5F3EF]">
              こんなお悩み、<br />
              <span className="text-[#B8860B]">ありませんか？</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="rounded-2xl border border-[#F5F3EF]/10 bg-white/5 backdrop-blur-sm p-6 lg:p-8 transition-all duration-300 hover:bg-white/10"
                >
                  <div className={`flex h-12 w-12 items-center justify-center rounded-xl mb-5 ${value.isExcel ? 'bg-[#217346]/20' : 'bg-[#B8860B]/15'}`}>
                    <Icon className={`h-6 w-6 ${value.isExcel ? 'text-[#217346]' : 'text-[#C8913A]'}`} />
                  </div>
                  <h3 className="text-xl font-bold text-[#F5F3EF] mb-3">
                    {value.title}
                  </h3>
                  <p className="text-[#F5F3EF]/70 leading-relaxed text-justify">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <p className="text-[#F5F3EF]/70 mb-5">その悩み、Senriganが解決します。</p>
            <a
              href="#contact"
              className="group inline-flex items-center justify-center gap-2 rounded-lg bg-[#B8860B] px-7 py-3.5 text-white font-semibold hover:bg-[#A0750A] transition-colors shadow-lg shadow-[#B8860B]/30"
            >
              まずは無料で相談する（30分）
              <ArrowRight className="h-4 w-4 transform group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
